import React from 'react';
import ReactQuill from 'react-quill-new';
import 'react-quill-new/dist/quill.snow.css';

const modules = {
  toolbar: [
    [{ header: [2, 3, false] }],
    ['bold', 'italic', 'underline'],
    [{ list: 'ordered' }, { list: 'bullet' }],
    ['link'],
    ['clean']
  ]
};

const formats = ['header', 'bold', 'italic', 'underline', 'list', 'link'];

const RichTextEditor = ({ value, onChange, placeholder }) => {
  return (
    <div className="rich-text-editor">
      <ReactQuill
        theme="snow"
        value={value || ''}
        onChange={onChange}
        modules={modules}
        formats={formats}
        placeholder={placeholder}
      />
      <style>{`
        .rich-text-editor .ql-container { min-height: 100px; font-size: 14px; }
        .rich-text-editor .ql-editor { min-height: 100px; }
        .rich-text-editor .ql-toolbar { border-radius: 8px 8px 0 0; border-color: #e5e7eb; }
        .rich-text-editor .ql-container { border-radius: 0 0 8px 8px; border-color: #e5e7eb; }
      `}</style>
    </div>
  );
};

export default RichTextEditor;
